import * as React from "react"
import {ButtonIconSeeker} from "@ui-seeker/core";
import { dsColorNew } from "@palette";
import { alpha } from "@mui/material/styles"


export default function ToolbarButton({ icon, iconWeight="regular", ...props }) {
	return <ButtonIconSeeker
		icon={icon}
		iconWeight={iconWeight}
		{...props}
		sx={{
			width: 32, height: 32,
			borderRadius: '8px',
			border: `1px solid ${alpha(dsColorNew.black, 0.08)}`,
			backgroundColor: dsColorNew.white,
			color: dsColorNew.textMuted,
			boxShadow: 'none',
			'&:hover': { backgroundColor: dsColorNew.filterInputBg, boxShadow: `0 1px 4px ${alpha(dsColorNew.black, 0.08)}`, borderColor: alpha(dsColorNew.black, 0.12) },
			...props?.sx
		}}
	/>
}